package org.zq.flvtomp4.platform

import kotlinx.browser.document
import kotlinx.coroutines.suspendCancellableCoroutine
import org.w3c.dom.HTMLInputElement
import org.w3c.files.get
import kotlin.coroutines.resume

actual object PlatformFiles {
    actual fun fileName(path: String): String =
        path.substringAfterLast('/').ifBlank { path }

    actual fun parent(path: String): String? {
        val index = path.lastIndexOf('/')
        return if (index > 0) path.substring(0, index) else null
    }

    actual fun join(dir: String, name: String): String =
        dir.trimEnd('/') + "/" + name.trimStart('/')

    actual fun exists(path: String): Boolean =
        WebFileStore.getInput(path) != null

    actual fun delete(path: String): Boolean = false

    actual fun isDirectory(path: String): Boolean = false

    actual fun collectFlvFiles(paths: List<String>): List<String> =
        paths.filter {
            it.endsWith(".flv", ignoreCase = true) || WebFileStore.getInput(it) != null
        }

    actual suspend fun pickFlvFiles(): List<String> =
        suspendCancellableCoroutine { cont ->
            val input = document.createElement("input") as HTMLInputElement
            input.type = "file"
            input.accept = ".flv,video/x-flv,video/flv"
            input.multiple = true
            input.style.display = "none"
            document.body?.appendChild(input)

            fun finish(paths: List<String>) {
                runCatching { document.body?.removeChild(input) }
                if (cont.isActive) cont.resume(paths)
            }

            input.onchange = {
                val fileList = input.files
                if (fileList == null || fileList.length == 0) {
                    finish(emptyList())
                } else {
                    val files = buildList {
                        for (i in 0 until fileList.length) {
                            fileList[i]?.let { add(it) }
                        }
                    }
                    finish(WebFileStore.registerInputs(files))
                }
            }
            cont.invokeOnCancellation {
                runCatching { document.body?.removeChild(input) }
            }
            input.click()
        }

    actual fun pickDirectory(): String? = null

    actual fun pickExecutable(title: String): String? = null

    actual fun openDirectory(path: String) {
        WebFileStore.downloadOutput(path)
    }

    actual fun resolveOutputPath(
        inputPath: String,
        outputDir: String?,
        overwrite: Boolean,
    ): String = WebFileStore.defaultOutputPath(inputPath)
}
